import { Component } from '@angular/core';
import { Http } from '@angular/http';
import { NceAdminService } from '../services/nce-admin.service';

import { STATIC_VALUE } from '../../shared/configuration/static.value';

import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';

import {LazyLoadEvent} from 'primeng/components/common/api';
import {FilterMetadata} from 'primeng/components/common/api';

@Component({
    selector: 'nce-admin-all',
    templateUrl: 'all.component.html'
})
export class NceAdminAllComponent{

    totalNCERecords: number;
    currentStart: number;
    currentEnd: number;

    vPageSize: number = STATIC_VALUE.TABLE.PAGE_SIZE;

    vLoading: boolean = false;

    // vNCERequestID: string = '';
    vNCEStatus: string = '';

    resettedNceTable: number = 0;

    vNCESearchBy: string = '';
    vNCEFilterBy: string = '';
    vNCEDate: Date;
    
    vNCELists: Array<{
        nce_record_id: number,
        nce_request_id: string,
        create_date: string,
        updated_date: string,
        location_earthwork: string,
        appointment_date: string,
        appointment_time: string,
        status: string
    }>;

    constructor(
        private _http: Http,
        private _nceAdminService: NceAdminService,
        private _pageNavigationService: PageNavigationService,
        private _layoutService: LayoutService,
    ){}

    ngOnInit(){
        this._layoutService.setCurrentPage('nce-admin-all');

        this.vLoading = true;
        this._nceAdminService.loadTotalData(this.vNCESearchBy, this.vNCEFilterBy, this.vNCEStatus).then(
            (resolve) => {
                //this.totalRecords = this._nceAdminService.getTotalData();
                this._nceAdminService.loadNCE(0, this.vPageSize, this.vNCESearchBy, this.vNCEFilterBy, this.vNCEStatus).then(
                    (resolve) => {
                        this.vLoading = false; 
                        this.totalNCERecords = this._nceAdminService.getTotalData();
                        this.vNCELists = this._nceAdminService.getNCEList();
                        this.currentStart = 1;
                        this.currentEnd = 1*10;
                    },
                    (reject) => {
                        this.vLoading = false;
                    }
                );
            },
            (reject) => {
                this.vLoading = false;
            }
        );
        this._nceAdminService.loadAllNCEStatus();
        
        this.vNCESearchBy = this.getSearchBy()[0].type;
    }

    getNCEStatusList() {
		return this._nceAdminService.getAllNceStatus();
    }

    getSearchBy() {
        let data = [];
        for(let nce of STATIC_VALUE.SEARCH_BY.admin){
            if(nce.nceValue !== ''){
                data.push(nce);
            }
        }
		return data;
    }

    resetNCEFilter() {
        this.vNCEFilterBy = '';
        this.vNCEDate = null;
    }

    clearInputNCE(){
        this.resetNCEFilter();
        this.filterNCE();
    }
    
    filterDateNCE() {
        this.vNCEFilterBy = this.vNCEDate.getFullYear() + '' + ("0" + (this.vNCEDate.getMonth() + 1)).slice(-2) + '' + ("0" + this.vNCEDate.getDate()).slice(-2);
        this.filterNCE();
    }

    filterNCE(){
        this.vLoading = true;
        this.resettedNceTable = 0;
        this._nceAdminService.loadTotalData(this.vNCESearchBy, this.vNCEFilterBy, this.vNCEStatus).then(
            (resolve) => {
                //this.totalRecords = this._nceAdminService.getTotalData();
                this._nceAdminService.loadNCE(0, this.vPageSize, this.vNCESearchBy, this.vNCEFilterBy, this.vNCEStatus).then(
                    (resolve) => {
                        this.vLoading = false; 
                        this.totalNCERecords = this._nceAdminService.getTotalData();
                        this.currentStart = 1;
                        this.currentEnd = 1*10;
                        this.vNCELists = this._nceAdminService.getNCEList();
                    },
                    (reject) => {
                        this.vLoading = false;
                    }
                );
            },
            (reject) => {
                this.vLoading = false;
            }
        );
    }

    loadNCELazy(event: LazyLoadEvent) {

        if(this.vLoading){
            return;
        }

        let vPageNumber = event.first/this.vPageSize;

        this.vLoading = true;
        this._nceAdminService.loadNCE(vPageNumber, this.vPageSize, this.vNCESearchBy, this.vNCEFilterBy, this.vNCEStatus).then(
            (resolve) => {
                this.vLoading = false;
                this.vNCELists = this._nceAdminService.getNCEList();
                this.currentStart = ((vPageNumber+1)*10)-9;
                this.currentEnd = (vPageNumber+1)*10 > this.totalNCERecords ? this.totalNCERecords : (vPageNumber+1)*10;
            },
            (reject) => {
                this.vLoading = false;
            }
        );
    }

    generateCSV() {
        if(this.vLoading){
            return;
        };

        this.vLoading = true;
        this._nceAdminService.getLinkCSV(this.vNCESearchBy, this.vNCEFilterBy, this.vNCEStatus).then(
            (resolve) => {
                const xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = (event) => {
                    /* Create a new Blob object using the response
                    *  data of the onload object.
                    */
                    const blob = new Blob([xhr.response], { type: 'text/csv' });
                    const a: any = document.createElement('a');
                    a.style = 'display: none';
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = 'nce_list.csv';
                    a.click();
                    window.URL.revokeObjectURL(url);
                    this.vLoading = false;
                };
                xhr.open('GET', resolve.toString());
                xhr.send();               
            },
            (reject) => {
                this.vLoading = false;
            }
        );        
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce-admin/components/all.component.ts